export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pc-404-41df54c643c45f7d4f60598fc961a578.png";